import { render, staticRenderFns } from "./Summarize.vue?vue&type=template&id=1ea298b2&"
import script from "./Summarize.vue?vue&type=script&lang=js&"
export * from "./Summarize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports